import React from 'react';
import { motion } from 'framer-motion';
import { FiCheck, FiStar } from 'react-icons/fi';
import './Pricing.css';

const Pricing = () => {
  const plans = [
    {
      name: '1 Mês',
      price: '24.99',
      period: 'mês',
      description: 'Plano mensal',
      popular: false,
      color: '#00c546',
      features: [
        '10.000+ canais',
        'Qualidade até 4K Ultra HD',
        'Todos os dispositivos',
        '1 tela por assinatura',
      ],
    },
    {
      name: '3 Meses',
      price: '55',
      period: '3 meses',
      description: 'Ou 3 pontos de acesso',
      popular: true,
      color: '#00c546',
      features: [
        '10.000+ canais',
        'Qualidade até 4K Ultra HD',
        'Todos os dispositivos',
        '1 tela por assinatura',
        'Suporte prioritário',
      ],
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut',
      },
    },
  };

  return (
    <section id="pricing" className="pricing">
      <div className="pricing-container">
        <motion.div
          className="pricing-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="section-badge">Planos</div>
          <h2 className="section-title">
            Escolha o Plano
            <span className="gradient-text"> Perfeito Para Você</span>
          </h2>
          <p className="section-description">
            Escolha o período que melhor se adapta a você. Todos os planos incluem os mesmos recursos.
          </p>
        </motion.div>

        <motion.div
          className="pricing-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
        >
          {plans.map((plan, index) => (
            <motion.div
              key={index}
              className={`pricing-card ${plan.popular ? 'popular' : ''}`}
              variants={cardVariants}
              whileHover={{ y: -10, scale: 1.02 }}
              transition={{ duration: 0.3 }}
            >
              {plan.popular && (
                <div className="popular-badge">
                  <FiStar />
                  <span>Mais Popular</span>
                </div>
              )}

              <div className="pricing-card-header">
                <h3 className="plan-name">{plan.name}</h3>
                <p className="plan-description">{plan.description}</p>
              </div>

              <div className="pricing-amount">
                <span className="currency">R$</span>
                <span className="price">{plan.price}</span>
                <span className="period">/{plan.period}</span>
              </div>

              <motion.a
                href="https://wa.me/message/UZEOSUXP7IXTD1"
                className="pricing-btn"
                style={{
                  background: plan.popular
                    ? `linear-gradient(135deg, ${plan.color}, #00a33a)`
                    : `linear-gradient(135deg, ${plan.color}20, ${plan.color}10)`,
                  color: plan.popular ? 'white' : plan.color,
                  border: `2px solid ${plan.color}40`,
                }}
                whileHover={{ scale: 1.05, boxShadow: `0 10px 40px ${plan.color}40` }}
                whileTap={{ scale: 0.95 }}
              >
                {plan.popular ? 'Escolher Plano' : 'Escolher Plano'}
              </motion.a>

              <div className="pricing-features">
                {plan.features.map((feature, idx) => (
                  <motion.div
                    key={idx}
                    className="feature-item"
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.1 + idx * 0.05 }}
                  >
                    <FiCheck className="check-icon" style={{ color: plan.color }} />
                    <span
                      style={{
                        fontWeight: feature === 'Suporte prioritário' ? 700 : 400,
                        color: feature === 'Suporte prioritário' ? plan.color : 'inherit',
                      }}
                    >
                      {feature}
                    </span>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          className="pricing-footer"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.5 }}
        ></motion.div>
      </div>
    </section>
  );
};

export default Pricing;
